import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_CREATE = graphql(/* GraphQL */ `
  mutation TesseractContractDemandCreate {
    tesseract {
      contractDemandCreate {
        id
        createdAt
        updatedAt
        priority
        responsibleUserId
        sequenceNumber
        tagIds
        demandRequest {
          commodityGroupId
          createdAt
          currency
          id
          incoTermsId
          requestedAt
          totalValue
          validityPeriod {
            from
            to
          }
          lineItems {
            baselinePricePerUnit
            commodityGroupId
            commodityId
            createdAt
            deliveryLocationId
            description
            id
            minimumOrderQuantity
            quantity
            title
            unitId
          }
        }
        competitiveBiddingRule {
          id
          biddingPeriodDays
          deadline
          deadlineExceeded
          variant
        }
      }
    }
  }
`);
